/**
 * Página placeholder para botones que apuntan a funcionalidad aún no
 * construida (ej: "Cómo pagar" del Dashboard, "Datos para transferir"
 * del Footer).
 *
 * Sprint 11 v2 S11-V2-03. Reemplaza por modal/página real cuando
 * Sprint 12+ defina los flujos correspondientes.
 */
export function SinImplementar() {
  return (
    <div className="px-8 py-12">
      <h2 className="text-2xl font-medium text-text-primary mb-3">
        Sección en construcción
      </h2>
      <p className="text-base text-text-secondary mb-2">
        Esta funcionalidad está en desarrollo. La Comisión te avisará cuando esté disponible.
      </p>
      <p className="text-sm text-text-muted">
        Mientras tanto, sigue usando los canales habituales (transferencia bancaria
        indicando &quot;Casa NNNN&quot; en el mensaje).
      </p>
    </div>
  );
}
